import { TableFilterTypes } from '@ge/models/constants';
export const TurbineHistoryColumns = {
  GROUP_CODE: 'group-code',
  CODE: 'code',

  GROUP_EVENT_CLASS: 'group-eventClass',
  EVENT_CLASS: 'eventClass',

  GROUP_DESCRIPTION: 'group-description',
  DESCRIPTION: 'desc',

  GROUP_START: 'group-start',
  START: 'startDate',

  GROUP_END: 'group-end',
  END: 'endDate',
};

// Define all available columns in the Turbine history table.
export const TurbineHistoryColumnDefs = {
  [TurbineHistoryColumns.GROUP_CODE]: {
    align: 'left',
    cols: {
      [TurbineHistoryColumns.CODE]: {
        minWidth: '70px',
        labels: [
          {
            a11yKey: 'turbineEventHistory.code',
            a11yDefault: 'EM#',
            sortValue: 'code',
          },
        ],
        filterType: TableFilterTypes.SEARCH,
      },
    },
  },
  [TurbineHistoryColumns.GROUP_EVENT_CLASS]: {
    align: 'left',
    cols: {
      [TurbineHistoryColumns.EVENT_CLASS]: {
        minWidth: '70px',
        labels: [
          {
            a11yKey: 'turbineEventHistory.eventClass',
            a11yDefault: 'Sev.',
            sortValue: 'eventClass',
          },
        ],
        filterType: TableFilterTypes.CHECKBOXES,
      },
    },
  },
  [TurbineHistoryColumns.GROUP_DESCRIPTION]: {
    align: 'left',
    cols: {
      [TurbineHistoryColumns.DESCRIPTION]: {
        minWidth: '160px',
        labels: [
          {
            a11yKey: 'turbineEventHistory.description',
            a11yDefault: 'EM Description',
            sortValue: 'desc',
          },
        ],
        filterType: TableFilterTypes.SEARCH,
      },
    },
  },
  [TurbineHistoryColumns.GROUP_START]: {
    align: 'left',
    cols: {
      [TurbineHistoryColumns.START]: {
        minWidth: '50px',
        labels: [
          {
            a11yKey: 'turbineEventHistory.startDate',
            a11yDefault: 'Start',
            sortValue: 'startDate',
          },
        ],
        filterType: TableFilterTypes.DATE,
      },
    },
  },
  [TurbineHistoryColumns.GROUP_END]: {
    align: 'left',
    cols: {
      [TurbineHistoryColumns.END]: {
        minWidth: '50px',
        labels: [
          {
            a11yKey: 'turbineEventHistory.endDate',
            a11yDefault: 'Stop',
            sortValue: 'endDate',
          },
        ],
        filterType: TableFilterTypes.DATE,
      },
    },
  },
};

// Define the default visible columns and their order.
// NOTE: Defining this in one place because currently all

export const defaultTurbineHistoryCols = [
  {
    id: TurbineHistoryColumns.GROUP_CODE,
    cols: [
      {
        id: TurbineHistoryColumns.CODE,
        visible: true,
      },
    ],
  },
  {
    id: TurbineHistoryColumns.GROUP_EVENT_CLASS,
    cols: [
      {
        id: TurbineHistoryColumns.EVENT_CLASS,
        visible: true,
      },
    ],
  },
  {
    id: TurbineHistoryColumns.GROUP_DESCRIPTION,
    cols: [
      {
        id: TurbineHistoryColumns.DESCRIPTION,
        visible: true,
      },
    ],
  },
  {
    id: TurbineHistoryColumns.GROUP_START,
    cols: [
      {
        id: TurbineHistoryColumns.START,
        visible: true,
      },
    ],
  },
  {
    id: TurbineHistoryColumns.GROUP_END,
    cols: [
      {
        id: TurbineHistoryColumns.END,
        visible: true,
      },
    ],
  },
];
